import { useEffect, useCallback } from "react";
import { toast } from "react-toastify";
import useApiClient, { apiRoutes } from "../../../../hooks/apiClient";

const useVisualizarDocumento = ({ dadosOs }) => {
  const {
    request: requestDownload,
    data: dataDownload,
    errors: errorDownload,
    isLoading: isLoadingDocumento,
  } = useApiClient();

  const handleImprimirDocumento = useCallback(() => {
    const dados = {
      sequencialComunicado: dadosOs.sequencialComunicado,
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialAtividade: dadosOs.sequencialAtividadeComunicado,
    };

    requestDownload(apiRoutes.fiscalizacao.ordemservico.gerarVisualizacaoDocumento, dados);
  }, [requestDownload, dadosOs]);

  const handleImprimirDocAutoInfracaco = useCallback(() => {
    const dados = {
      sequencialAcaoFiscal: dadosOs.acaoFiscal,
      sequencialOrdemServico: dadosOs.sequencial,
      sequencialProdutoAcaoFiscal: null,
      sequencialComunicado: dadosOs.sequencialComunicado,
      siglaAtividade: "AI1",
      listaOcorrencias: dadosOs.ocorrencias,
    };

    requestDownload(apiRoutes.fiscalizacao.ordemservico.gerarDocAutoInfracaoParaVisualizar, dados);
  }, [requestDownload, dadosOs]);

  // download
  const handleDownload = useCallback(() => {
    if (dataDownload) {
      const file = new Blob([dataDownload], { type: "application/pdf" });
      const url = URL.createObjectURL(file);
      window.open(url, "", "width=800,height=800");
    }
    if (errorDownload) {
      toast.error(errorDownload.message);
    }
  }, [dataDownload, errorDownload]);

  useEffect(() => {
    handleDownload();
  }, [handleDownload]);

  return { handleImprimirDocumento, handleImprimirDocAutoInfracaco, isLoadingDocumento, dataDownload, errorDownload };
};

export default useVisualizarDocumento;
